<template>
  <div id="Phbo">
    <div id="Phbo-top"></div>
    <div id="Phbo-body">
      <div class="Phbo-title">
        <p class="Phbo-title-before"></p>
        <p class="Phbo-title-middle">量表系统</p>
        <p class="Phbo-title-after"></p>
      </div>
      <div class="Phbo-content1">
        <ul>
          <li v-for="item in PhboContent1Items">
            <p class="Phbo-content-text-before"></p>
            <p class="Phbo-content-text">{{item.msg}}</p>
          </li>
        </ul>
      </div>
      <div class="Phbo-title">
        <p class="Phbo-title-before"></p>
        <p class="Phbo-title-middle">数据信息管理</p>
        <p class="Phbo-title-after"></p>
      </div>
      <div class="Phbo-content2">
        <div class="Phbo-content2-left">
          <ul>
            <li v-for="item in PhboContent2LeftItems">
              <p class="Phbo-content-text-before"></p>
              <p class="Phbo-content-text">{{item.msg}}</p>
            </li>
          </ul>
        </div>
        <div class="Phbo-content2-right">
          <ul>
            <li v-for="item in PhboContent2RightItems">
              <p class="Phbo-content-text-before"></p>
              <p class="Phbo-content-text">{{item.msg}}</p>
            </li>
          </ul>
        </div>
      </div>
      <div class="Phbo-title">
        <p class="Phbo-title-before"></p>
        <p class="Phbo-title-middle">质量管控</p>
        <p class="Phbo-title-after"></p>
      </div>
      <div>
        <p class="Phbo-content-middle-text">实时监控完成情况，可以按学校、地区、省、市的统计方式展示项目的完成进度</p>
      </div>
      <div class="Phbo-title">
        <p class="Phbo-title-before"></p>
        <p class="Phbo-title-middle">标准的RESTful接口</p>
        <p class="Phbo-title-after"></p>
      </div>
      <div>
        <p class="Phbo-content-middle-text">基于role权限控制的接口管理。</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Phbo',
  data(){
    return{
      PhboContent1Items:[
        {msg:'支持PHP,JS,HTML等网络编程语言定制开发'},
        {msg:'可用于创建简单小巧的调查问卷，也可创建大型、复杂、具有层次结构的调查问卷，并可以实现与外部数据库对接的功能'},
        {msg:'根据调查的性质，可以在系统中预先设定相应类型的字段，具体包括：问题、答案、备注、"不知道"和"拒绝回答"、多语言文字选项等等。'},
        {msg:'针对不同的访问模式提供了不同的数据输入机制'},
        {msg:'可以在数据模型中设定各种复杂的跳转，以实现选择性提问的功能'},
        {msg:'可以预先设定数据有效区间，避免出现数据输入错误。程序中存在两种校验模式：强制性检验(Hard)和提示性校验(Soft)。'},
        {msg:'提供大量版面设计的控制选项。可以自己定制调查问卷的版面(包括所有界面的字体、位置和颜色等)和大量操作行为选项'},
        {msg:'提供对数据编辑，数据录入员功能'},
        {msg:'支持持续作答，允许中途退出自动保存答案'},
        {msg:'支持移动端和PC端'}
      ],
      PhboContent2LeftItems:[
        {msg:'多级用户权限管理'},
        {msg:'批量数据导入、删除'},
        {msg:'数据同步'}
      ],
      PhboContent2RightItems:[
        {msg:'支持同时管理多个调查数据：多个横向调研数据、队列调研数据'},
        {msg:'允许自定义每次调查的数据模板'},
        {msg:'图形化数据展示'}
      ]
    }
  }
}
</script>

<style lang="scss">
#Phbo-top{
  height: 600px;
  background-size: auto 100%;
  background-position:center;
  background-repeat: no-repeat;
  background-image: url(../../assets/images/ProductAndService/Phbo/Phbo_Banner.png);
}
#Phbo-body{
  padding-top: 20px;
  padding-bottom: 60px;
}
.Phbo-title{
  text-align: center;
  margin-top: 40px;
  margin-bottom: 20px;
}
.Phbo-title .Phbo-title-middle {
  font-size: 24px;
  color: #282828;
  display: inline-block;
  vertical-align:middle;
}
.Phbo-title .Phbo-title-before{
  width: 6px;
  height: 6px;
  display: inline-block;
  background-color: #000;
  -moz-border-radius: 3px;
  -webkit-border-radius: 3px;
  border-radius: 3px;
}
.Phbo-title .Phbo-title-after{
  width: 6px;
  height: 6px;
  display: inline-block;
  background-color: #000;
  -moz-border-radius: 3px;
  -webkit-border-radius: 3px;
  border-radius: 3px;
}
#Phbo-body .Phbo-content1{
  width: 650px;
  display: inline-block;
}
#Phbo-body .Phbo-content2{
  width: 630px;
  display: inline-block;
}
#Phbo-body .Phbo-content2 .Phbo-content2-left{
  width: 274px;
  float: left;
}
#Phbo-body .Phbo-content2 .Phbo-content2-right{
  width: 356px;
  float: right;
}
#Phbo-body .Phbo-content1 li{
  text-align: left;
  line-height:30px;
}
#Phbo-body .Phbo-content2 li{
  text-align: left;
  line-height:30px;
}
#Phbo-body .Phbo-content-text{
  font-size: 14px;
  color: #909090;
  padding-left: 20px;
}
#Phbo-body .Phbo-content-text-before{
    width: 10px;
    height: 10px;
    float: left;
    background-color: #909090;
    margin-right: 10px;
    margin-top: 10px;
    -moz-border-radius: 5px;
    -webkit-border-radius: 5px;
    border-radius: 5px;
}
#Phbo-body .Phbo-content-middle-text{
  font-size: 14px;
  color: #909090;
}
</style>



// WEBPACK FOOTER //
// src/pages/ProductAndService/Phbo.vue